import React from 'react';
export default {
  'cart': {
    'change-currency': 'Changer la devise',
    'and-then': 'Puis',
    'plus-tax': ' + les taxes',
    'for': 'Pour',
    'edit': {
      'label': 'Modifier',
      'submit': 'Appliquer'
    },
    'empty': "Vous n'avez encore rien ajouté à votre commande.",
    'free': 'gratuit',
    'promo-code': {
      'add': 'Ajouter une carte-cadeau ou un code promo',
      'error': {
        'invalid-for-subscription': 'Le code promo n\'est pas valable pour cette commande.'
      },
      'label': 'Carte-cadeau ou code promo',
      'submit': 'Appliquer'
    },
    'subtotal-line': {
      'tax-label': 'Estimation des taxes',
      'subtotal': 'Sous-total',
      'tax': 'Taxe',
      'gift-card': 'Carte Cadeau'
    },
    'starting-price': 'Prix de départ',
    'title': 'Résumé de la commande',
    'setup-fee': 'frais de mise en place',
    'free-trial': 'essai gratuit',
    'total-line': {
      'label': 'Total'
    },
    'order-total-line': {
      'label': 'Total de la commande'
    }
  },
  'address': {
    'country': 'Pays',
    'address2': 'Appartement, suite, etc.',
    'tax-identifier': 'Identifiant fiscal',
    'tax-identifier-type': "Type d'identifiant fiscal",
    'first-name': 'Prénom',
    'last-name': 'Nom de famille',
    'company-name': "Nom de l'entreprise",
    'address1': 'Adresse',
    'city': 'Ville',
    'state': 'Province',
    'postal-code': 'Code postal',
    'phone-number': 'Numéro de téléphone',
    'vat-number': 'Numéro TVA/ID Fiscal'
  },
  'payment-method': {
    'credit-card': {
      'label': 'Informations de la carte',
      'expiry': 'MM/AA',
      'name': 'Carte De Crédit',
      'number': 'Numéro de carte de crédit',
      'cvv': 'CVV',
      'brand': {
        'visa': 'Visa',
        'master': 'MasterCard',
        'cartes_bancaires': 'Cartes Bancaires'
      }
    },
    'ach': {
      'name': 'Compte Bancaire',
      'routing-number': 'Nombre de routage',
      'account-number': 'Numéro de compte',
      'account-number-confirmation': 'Confirmez le numéro de compte',
      'account-type': {
        'label': 'Type de compte',
        'checking': 'Compte Courant',
        'savings': "Compte d'épargne"
      },
      'name-on-account': 'Nom sur le compte'
    },
    'amazon': {
      'name': 'Amazon'
    },
    'apple-pay': {
      'name': 'Apple Pay'
    },
    'boleto': {
      'name': 'Boleto'
    },
    'bacs': {
      'name': 'Bacs',
      'sort-code': 'Sort Code'
    },
    'becs': {
      'name': 'BECS',
      'bsb-code': 'BSB Code'
    },
    'google-pay': {
      'name': 'Google Pay'
    },
    'ideal': {
      'name': 'Ideal'
    },
    'paypal': {
      'name': 'PayPal'
    },
    'qiwi_wallet': {
      'name': 'Qiwi Wallet'
    },
    'sepa': {
      'name': 'SEPA',
      'iban': 'IBAN'
    },
    'sofort': {
      'name': 'Sofort'
    },
    'venmo': {
      'name': 'Venmo'
    }
  },
  'billing-address': 'Adresse de facturation',
  'billing-address-same-as-shipping': 'Identique à l’adresse de livraison',
  'submit': 'Payer maintenant',
  'payment-method-selected': ({ paymentMethod }: { paymentMethod: string }) => <>{paymentMethod} sélectionné</>,
  'express-checkout': 'Paiement express',
  'change-payment-method': 'Changer le mode de paiement',
  'day': 'jour',
  'days': 'jours',
  'week': 'semaine',
  'weeks': 'semaines',
  'month': 'mois',
  'months': 'mois',
  'year': 'année',
  'years': 'années',
  'confirmation': {
    'title': 'Nous vous remercions pour votre commande',
    'order-num': ({ number }: { number: number }) => <>Commande #{number}</>,
    'fulfilled-on': ({ date }: { date: string }) => <>Effectuée le {date}</>,
    'email-notice': 'Vous recevrez un e-mail de confirmation de votre commande.',
    'payment': 'Paiement',
    'return-to': ({ name }: { name: string }) => <>Revenir à {name}</>,
    'credit-applied': 'Crédit Appliquée'
  },
  'back': 'Retour',
  'contact-info': 'Coordonnées',
  'email-address': 'email',
  'payment-info': 'Renseignements sur la facturation',
  'shipping-address': 'Adresse de livraison',
  'legal': {
    'accept': "J'accepte le",
    'privacy-policy': 'Politique de confidentialité',
    'terms-of-service': 'Conditions de service'
  },
  'recurring': {
    'consent': `J'accepte de payer les frais ci-dessus, affichés avec une fréquence de facturation, sur une base récurrente,
                à moins que l'abonnement ne soit annulé avant la fin de la période de facturation en cours.`,
    'cancel': 'Pour annuler votre abonnement, visitez votre page de gestion de compte.'
  },
  'pluralize': {
    'days': ({ count }: { count: number }) => count === 1 ? 'jour' : 'jours',
    'weeks': ({ count }: { count: number }) => count === 1 ? 'semaine' : 'semaines',
    'months': ({ count }: { count: number }) => count === 1 ? 'mois' : 'mois',
    'years': ({ count }: { count: number }) => count === 1 ? 'année' : 'années'
  },
  'subscription': {
    'details': {
      'addons': {
        'flat.charge': ({ amount, addOnName }: { amount: string; addOnName: string }) => <>Vous serez facturé {amount}/unité pour {addOnName}</>,
        'no-flat.charge': ({ amount, units, unitsLabel, addOnName }: { amount: string; units: number; unitsLabel: string; addOnName: string }) => <>Vous serez facturé {amount} pour {units} {unitsLabel} de {addOnName}</>
      },
      'billing.starting': ({ startDate, amount, intervalLengthLabel, taxable = true }: { startDate: string; amount: string; intervalLengthLabel: string; taxable?: boolean }) => <>À partir du {startDate}, vous serez facturé {amount}/{intervalLengthLabel}{taxable ? ' + taxes' : ''}</>,
      'billing.starting.setupfee': ({ startDate, amount, intervalLengthLabel, setupFee, taxable = true }: { startDate: string; amount: string; intervalLengthLabel: string; setupFee: string; taxable?: boolean }) => <>À partir du {startDate}, vous serez facturé {amount}/{intervalLengthLabel}{taxable ? ' + taxes' : ''}, ainsi que des frais uniques de {setupFee}</>,
      'cancellation.reminder': 'Vous recevrez un rappel par e-mail {days} jours avant le début de la facturation.',
      'trial.start': ({ trialLength, trialInterval }: { trialLength: string; trialInterval: string }) => <>Votre essai gratuit de {trialLength} {trialInterval} commence aujourd'hui.</>,
      'trial.ends': ({ trialEndsAt }: { trialEndsAt: string }) => <>Pour éviter d'être facturé, vous devez annuler avant le {trialEndsAt}.</>,
      'email.reminder': ({ days }: { days: number }) => <>Vous recevrez un rappel par e-mail {days} jours avant le début de la facturation</>,
      'no-renewal': ({ billingEndsAt }: { billingEndsAt: string }) => <>Votre abonnement se terminera le {billingEndsAt} et ne se renouvellera pas automatiquement.</>,
      'ramp.after': ({ afterChargeTime, newChargeAmount }: { afterChargeTime: string; newChargeAmount: string }) => <>Après {afterChargeTime}, vous serez facturé {newChargeAmount} + taxes</>,
      'renewal': ({ totalCyclesLengthLabel }: { totalCyclesLengthLabel: string }) => <>Votre abonnement se renouvellera automatiquement tous les {totalCyclesLengthLabel} et continuera jusqu'à ce que vous l'annuliez.</>,
      'title': 'Détails de l\'abonnement',
    },
    'agreement.button': 'Accepter et continuer',
    'agreement.text': 'En cliquant sur "Accepter et continuer", vous confirmez que vous comprenez et acceptez ces conditions d\'abonnement. Aucun frais ne s\'appliquera tant que vous n\'aurez pas terminé votre commande.',
    'changeOrCancel': 'Pour modifier ou annuler votre abonnement ',
    'access-account': 'accédez à votre compte',
    'contact-support': 'contactez le support',
  },
  'currency-display': ({ currency }: { currency: string }) => <>{(currency || '').toUpperCase()}</>,
  'support': {
    'array': {
      'wordsConnector': ', ',
      'twoWordsConnector': ' et ',
      'lastWordConnector': ' et '
    }
  },
  'powered-by': ({ recurly }: { recurly: string }) => <>Abonnement facturé par {recurly}</>,
  'errors': {},
  'subscribe': "S'abonner"
};
